import {ENTITLEMENT_KEYS} from '@packages/domains/billing/constants';
import {defineAbilityConfig} from '../system/defineAbilityConfig';

/**
 * Determines whether the user can manage custom domains for the site.
 * This checks for the manage permission on siteCustomDomain resource.
 */
export const canManageCustomDomains = defineAbilityConfig({
  permission: ['manage', 'siteCustomDomain'],
} as const);

/**
 * Whether the Designer may offer creating a site 301 redirect (e.g. on page
 * move). Matches POST /sites/:siteSlug/redirect authZ + hosting: allow301
 * entitlement and siteCustomDomain.manage. Do not use siteRedirects.manage —
 * that gates delete-all, not create.
 */
export const canCreateSiteRedirects = defineAbilityConfig({
  entitlements: [ENTITLEMENT_KEYS.ALLOW_301],
  permission: ['manage', 'siteCustomDomain'],
} as const);

/**
 * Determines whether the user can publish to a custom domain.
 */
export const canPublishCustomDomain = defineAbilityConfig({
  entitlements: [ENTITLEMENT_KEYS.ALLOW_PUBLISH_DOMAIN],
} as const);
